/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { useStaticContent } from '@context/StaticContent';
// import { useActivation, useTariff } from '@context/MobileOne';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils';
import { usePayment } from '@context/Payment';
import {
  AmountSelection,
  ButtonPrimary,
  ButtonCancelActivation,
  NewsTeaserSmall,
  Notification,
  ScrollToTop,
  NavigationPageTitle,
  // ButtonWrapper,
  CardSupport
} from '@core/index';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { extractTeaserColors } from '@utils/teaserGradient';
import { appButtonType, appAlert, appTopUpType, parseToGermanPrice } from '@utils/globalConstant';
import { getCMSText } from '@utils/a11y/a11yHelpers';
import useCmsImage from '@utils/useCmsImage';

export function MpsAutoTopupAmount() {
  // Contexts
  const { tA11yTranslate } = useA11y();
  const { campaignContentData, mpsPaymentAmounts } = useStaticContent();
  const { setStep8SubStep } = useActivation();
  const { mpsActivationTopupPayment, setActivationMpsTopupPayment } = usePayment();

  // States
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [paymentRegTeaser, setPaymentRegTeaser] = useState(false);
  const [paymentRegTeaserBgColors, setPaymentRegTeaserBgColors] = useState({ bgColor1: '', bgColor2: '' });
  const [footnote, setFootnote] = useState('');

  // Reset previously stored amount when entering this page so the first
  // option always receives tabIndex=0 (BFSG: Tab from back arrow → €10, not €100).
  useEffect(() => {
    setActivationMpsTopupPayment((prev) => ({
      ...prev,
      amount: '',
      type: appTopUpType.AUTOMATIC,
      isAutoTopUp: true
    }));
  }, []);

  // Build campaign teasers from campaignRegTopupAutoAmountTeaser
  useEffect(() => {
    if (!campaignContentData) return;
    const teaserList = campaignContentData?.campaignRegTopupAutoAmountTeaser;
    if (!teaserList?.length) return;
    const itemsReduced = teaserList[0];
    setFootnote(teaserList[0]?.footnote);
    setPaymentRegTeaserBgColors(extractTeaserColors(itemsReduced));
    setPaymentRegTeaser(itemsReduced);
  }, [campaignContentData]);

  const paymentRegTeaserImageWeb = useCmsImage(paymentRegTeaser?.imageSourceWeb);
  const paymentRegTeaserImage = useCmsImage(paymentRegTeaser?.imageSource);

  // Prepare options for AmountSelection
  const amountOptions = mpsPaymentAmounts.map((amount) => ({
    id: String(amount),
    label: getCMSText(
      tA11yTranslate,
      'ek_tariff_options_spdon_crd_pirce1',
      parseToGermanPrice(amount, true, true),
      '{PRICE_EUR}'
    ).content
  }));

  const handleAmountSelect = (amountId) => {
    setActivationMpsTopupPayment((prev) => ({
      ...prev,
      amount: amountId
    }));
  };

  const handleSubmit = () => {
    setSubmitAttempted(true);
    if (!mpsActivationTopupPayment.amount) return;
    setStep8SubStep(3);
  };

  // if (paymentRegTeaser) {
  //   console.log('paymentRegTeaser TRUE:', paymentRegTeaser);
  // } else {
  //   console.log('paymentRegTeaser FALSE:', paymentRegTeaser);
  // }
  

  return (
    <ScrollToTop>
      <AppPageContentWrapper>
        <div className="mb-24">
          <NavigationPageTitle title="ek_global_pymnt_amnt_hdl1" variant="sm" headingTag="h2" />
        </div>

        {paymentRegTeaser && (
          <div className="mb-24">
            <NewsTeaserSmall
              className="w-100"
              hasChip={!!paymentRegTeaser.chipTitle}
              chipTitle={paymentRegTeaser.chipTitle}
              chipTitleColor={paymentRegTeaser.chipTitleColorLight}
              chipIcon={paymentRegTeaser.chipIconWeb}
              badgeColor={paymentRegTeaser.chipBgColorLight || 'white'}
              headline={paymentRegTeaser.teaserTitle}
              hasImage
              imageSrc={paymentRegTeaserImageWeb?.media_url_display || paymentRegTeaserImage?.media_url_display || ''}
              buttonHref={paymentRegTeaser.redirectionLinkWeb}
              teaserStyle={paymentRegTeaser.teaserStyle || 'plain'}
              linearGradient={paymentRegTeaser.linearGradient || 'leftToRight'}
              bgColor1={paymentRegTeaserBgColors.bgColor1}
              bgColor2={paymentRegTeaserBgColors.bgColor2}
              teaserTitleColor="white"
            />
          </div>
        )}

        <div className="mt-8">
          <AmountSelection
            options={amountOptions}
            value={mpsActivationTopupPayment.amount}
            onChange={handleAmountSelect}
          />
          {submitAttempted && !mpsActivationTopupPayment.amount && (
            <div className="mt-16">
              <Notification
                type={appAlert.ERROR}
                message={
                  tA11yTranslate('ek_global_pymnt_amnt_err')?.content || 'Amount selection required'
                }
              />
            </div>
          )}
          <div className="my-48 d-flex gap-12">
            <ButtonPrimary
              buttonType={appButtonType.PRIMARY.DEFAULT}
              buttonContent={tA11yTranslate('ek_reg_autotopup_amnt_btn1')}
              onClick={handleSubmit}
            />
          </div>
        </div>

        {footnote && (
          <p className="ek-labeltext-12-medium mb-48">{footnote}</p>
        )}

        <div className="row">
          <CardSupport />
        </div>

        <div className="d-flex justify-content-center mt-32">
          <ButtonCancelActivation />
        </div>
      </AppPageContentWrapper>
    </ScrollToTop>
  );
}

export default MpsAutoTopupAmount;
